export const Resources = {
    SubscribeAriaLabel: 'Subscríbete aquí para recibir as últimas Noticias do Ministerio e/ou ás Notas de Prensa',
    BellGreetingLogged: 'Ola ',
    BellGreeting: 'Ola!',
    BellText01: 'Pode que che interese subscribirte ás seguintes',
    BellText02: 'A subscrición vincularase ao seguinte e-mail',
    BellText03: 'Se desexa modificalo, pode facelo na edición de datos de usuario',

    SubscribeTitle: 'Subscríbete',
    SubscribeTitleUperCase: 'SUBSCRÍBETE',
    SubscribeBtnTitle: 'Subscríbeche ás Newsletters do Ministerio',
    LoginSignUpUperCase: 'REXÍSTRATE',
    SubscriptionsManagerUperCase: 'XESTIÓN DE SUBSCRICIÓNS',

    Cancel: 'Cancelar',
    Ok: 'Ok',    

    SendActivationMailButton: 'Enviar correo electrónico de activación',
    SendActivationMailOK: 'Correo electrónico enviado correctamente ao correo proporcionado.',
    SendActivationMailError: 'Erro ao enviar a mensaxe. Por favor, ténteo de novo máis tarde.',
    
    LoginAuthentication: 'Identifícate',
    LoginRecoverPass: 'Recuperar contrasinal',
    LoginSignUpText: 'Se aínda non tes conta', 
    LoginButton: 'Botón Identifícate',   
    
    ToolTipCheckBell: 'Para eliminar a subscrición debe ir a Xestión de Subscricións',
    EnterEmail: 'Introduza o seu e-mail',
    EnterPass: 'Introduza o seu contrasinal',

    RecoveryAccountModal: 'Vaise a proceder ao envío dun correo de recuperación de contrasinal ao e-mail indicado',
    RecoveryAccountModalMailSended: 'Se o correo electrónico está rexistrado recibirá un e-mail na súa bandexa de entrada',

    //--------- Mensajes de Error -------------
    // SecurityPasswordChange: ServiceMessage1
    // InvalidCredentials: ServiceMessage3    
    // MailInUse: ServiceMessage4
    // DocInUso: ServiceMessage5
    // SendActivationEmailError: ServiceMessage6
    // SendRecoveryEmailError: ServiceMessage7
    // InvalidToken: ServiceMessage8
    // InternalServiceError: ServiceMessage9
    // GenerateJWTNoUser: ServiceMessage10
    // NoGroupId: ServiceMessage11
    // NoAuthenticated: ServiceMessage12
    // NoActiveUser: ServiceMessage13
    // NewActivationTokenError: ServiceMessage14
    // UserNoExist: ServiceMessage16

    ServiceMessage1: 'Melloramos  o sistema de seguridade para acceder a as súas subscricións, por iso é necesario cambiar o contrasinal. Pode facelo desde o apartado "Recuperar Contrasinal".',
    ServiceMessage2: '',
    ServiceMessage3: 'Non existe unha conta asociada ao correo electrónico indicado ou o contrasinal é incorrecto.',
    ServiceMessage4: 'O correo electrónico proporcionado atópase  en uso.',
    ServiceMessage5: 'Documento de identidade en uso.',
    ServiceMessage6: 'Usuario creado correctamente. Erro a o enviar o correo electrónico de activación de usuario.',
    ServiceMessage7: 'Erro a o enviar o correo electrónico de recuperación de usuario.',
    ServiceMessage8: 'O Identificador é incorrecto ou expirou. En caso de ser un usuario novo deberá proceder a un novo rexistro.',
    ServiceMessage9: 'Erro interno do servizo.',
    ServiceMessage10: 'Non se pode recuperar o usuario.',
    ServiceMessage11: 'Produciuse un erro na obtención das publicacións do usuario. Por favor, se o problema persiste, contacte co servizo técnico.',
    ServiceMessage12: 'Ningún usuario con sesión activa.',
    ServiceMessage13: 'O usuario aínda non activou a conta.',
    ServiceMessage14: 'Erro a o xerar un novo código de activación.',
    ServiceMessage15: '',
    ServiceMessage16: 'Non existe unha conta asociada ao correo electrónico indicado.',
    ServiceMessage17: 'O contrasinal actual non é correcto.',
    ServiceMessage19: "O novo contrasinal non pode ser igual que o contrasinal actual.",
    ServiceMessage21: "Debe completar o captcha.",

    ServiceMessage503: 'O servizo de subscricións non se atopa dispoñible, por favor, ténteo máis tarde. Desculpe as molestias.',
    
    ErrorCode0: 'Ok',
    ErrorCode1: 'O correo electrónico non pode estar baleiro',
    ErrorCode2: 'O correo electrónico é erróneo',
    ErrorCode3: 'O contrasinal non pode estar baleiro',
    ErrorCode4: 'Polo menos debe seleccionarse unha subscrición',
    ErrorCode5: 'Debe completar o captcha',
    ErrorCode6: 'O contrasinal elixido non é suficientemente seguro. Debe ter polo menos 8 caracteres, maiúsculas, minúsculas, números e símbolos. Os símbolos admitidos son: _!@#$%^&*.-',
}